import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { auth } from "../services/firebase";
import Footer from "../components/Footer";
import { randomColorHSL } from "../helpers/Types.js"

export default function HomePage(props) {
    useEffect(() => {
        document.querySelector('header').style.display='none';
    });

    let randCol = randomColorHSL();

    return (
        <>
        <div className="home">
            <section>
                <div className="spaceMessengersBg" >
                    <div className="container">
                        <h1 className="">SPACE BOARD</h1>
                        <h5 className="">A collaborative platform for Space Messengers AI</h5>
                        {/* <div style={{marginTop: "100px"}}> */}
                            {/* <Link className="btn waves-effect waves-light btn" to={(auth().currentUser?"/board":"/login")}>Login to Your Account</Link> */}
                        {/* </div> */}
                        <div className="row" id="LoginButtonContainer">
                            <div className="col s12 m11">
                                <Link className="btn waves-effect waves-light btn loginButton" style={{backgroundColor: randCol}} to={(auth().currentUser?"/board":"/login")}>Login to Your Account</Link>

                                <div className="card black loginInfo" style={{borderColor: randCol}} >
                                    <div className="card-content white-text">
                                        <p>SPACE BOARD is a digital platform for collecting "space messages"—reflections from youth, scientists, artists, and cultural specialists on the universe, science, technology, and our place within it. These messages are processed by Space Messengers' custom Language Learning Model (LLM), creating a growing AI-driven knowledge field. Participants contribute insights on cosmic phenomena, scientific discovery, and the intersection of technology, ethics, and society—forming a shared space for inquiry and imagination.<br/><br/>The "space messages" become part of the traveling Space Messengers AI installation, where they are dynamically visualized through interactive projections, motion tracking, and an immersive soundscape. This ever-growing archive invites communities into a space of collaborative world-building—exploring new possibilities, perspectives, and futures yet to be imagined.</p>
                                    </div>
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
        </>
    )
}
